import { Flex } from 'component-library/components/layout/Flex';
import React, { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

interface RowGapProps {
  rowGap: string;
}

interface ColumnGapProps {
  columnGap: string;
}

const TwoPanelNavigationWrapperContainer = styled(Flex)<
  RowGapProps & ColumnGapProps
>`
  flex-wrap: wrap;
  gap: ${({ rowGap, columnGap }) => `${rowGap} ${columnGap}`};
`;

interface NavigationMenuWidthProps {
  navigationMenuWidth: string;
}

const NavigationMenuContainer = styled(Flex)<NavigationMenuWidthProps>`
  width: ${({ navigationMenuWidth }) => navigationMenuWidth};
`;

const NavigationWrapper = styled.div`
  position: sticky;
  top: 125px;
`;

const ContentMenu = styled(Flex)<NavigationMenuWidthProps & ColumnGapProps>`
  flex-basis: ${({ navigationMenuWidth, columnGap }) =>
    `calc(100% - ${navigationMenuWidth} - ${columnGap})`};
`;

interface TwoPanelNavigationWrapperProps
  extends NavigationMenuWidthProps,
    RowGapProps,
    ColumnGapProps {
  leftHandNavigationMenu: React.ReactElement;
}

export const TwoPanelNavigationWrapper: FC<PropsWithChildren<
  TwoPanelNavigationWrapperProps
>> = ({
  columnGap,
  rowGap,
  leftHandNavigationMenu,
  navigationMenuWidth,
  children,
}) => (
  <TwoPanelNavigationWrapperContainer columnGap={columnGap} rowGap={rowGap}>
    <NavigationMenuContainer column navigationMenuWidth={navigationMenuWidth}>
      <NavigationWrapper>{leftHandNavigationMenu}</NavigationWrapper>
    </NavigationMenuContainer>
    <ContentMenu
      column
      navigationMenuWidth={navigationMenuWidth}
      columnGap={columnGap}
    >
      {children}
    </ContentMenu>
  </TwoPanelNavigationWrapperContainer>
);
